import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Field Card CVC'
export const group = ''

export default class ElFieldCardCvc extends SectionProvider {
  constructor (options = {}) {
    super('ElFieldCardCvc', options)

    this.name = name
    this.group = group
  }
}